module.exports = __webpack_public_path__ + "media/images/loading2-f5e89e2b646b926a767e6db7f228fa42.gif";